// Tipe produk keranjang tidak selalu sama dengan kategori voucher yang menutupinya:
// keranjang mixed e-billing memakai voucher `general`, dan perpanjangan konsultasi
// memakai voucher `consultation`. Permintaan daftar voucher dan filter di layar
// Checkout sama-sama lewat sini supaya keduanya sepakat voucher mana yang berlaku.
//
// Port dari mobile-user/src/utils/voucher.js.
export const getVoucherCategory = (productType) => {
  if (productType === "mixed-ebilling") {
    return "general";
  }
  if (productType === "consultation-extend") {
    return "consultation";
  }
  return productType || "";
};
